import { Entry } from '../Entry'

export function Entry20230503() {
  return (
    <Entry title="May 03 2023 - v3.3.11">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/13819/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
